export const API_URL = 'https://api.tizeti.com/api/v1';
export const GENIATECH_URL = 'https://legacy.tizeti.com/geniatechapi/index.php';
export const PAYSTACK_PUBLIC_KEY = "pk_live_48dd0c126b30e969b1b7eff9f27ded163647f4c6";
export const PAYSTACK_PUBLIC_KEY_MO = "pk_test_8a6bb69995275fd42c913994e3745cbe7f88b268";
export const PAYSTACK_TEST_PUBLIC_KEY = "pk_test_e1929473ff607af44d68b320871309eba86d377f";
export const VERIFY_PAYSTACK_URL = "https://api.paystack.co/transaction/verify";
export const VERIFICATION_URL = `https://api.tizeti.com/api/v1/paystack/verify?reference=`;
